var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b06518;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        opacity: .23;\n      }\n\n      .cls-2, .cls-41, .cls-42, .cls-43, .cls-3, .cls-4, .cls-25, .cls-26, .cls-27, .cls-28, .cls-38 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-6, .cls-25, .cls-27, .cls-28, .cls-38, .cls-39 {\n        fill: #fff;\n      }\n\n      .cls-41 {\n        opacity: .6;\n      }\n\n      .cls-42, .cls-28 {\n        opacity: .35;\n      }\n\n      .cls-43, .cls-4 {\n        opacity: .49;\n      }\n\n      .cls-44 {\n        mask: url(#mask);\n      }\n\n      .cls-3 {\n        opacity: .97;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-45 {\n        filter: url(#luminosity-noclip);\n      }\n\n      .cls-6 {\n        opacity: .7;\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient);\n        mix-blend-mode: multiply;\n      }\n\n      .cls-8 {\n        fill: #b55f09;\n        opacity: .25;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-25 {\n        opacity: .61;\n      }\n\n      .cls-26 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-27 {\n        opacity: .2;\n      }\n\n      .cls-29 {\n        fill: #fff064;\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-46 {\n        isolation: isolate;\n      }\n\n      .cls-38 {\n        opacity: .41;\n      }\n\n      .cls-47 {\n        mask: url(#mask-1);\n      }\n\n      .cls-40 {\n        fill: #ce7c1d;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 314.67,
    y1: 266.66,
    x2: 333.9,
    y2: 734.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7e436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce7c1d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -5677.21,
    y1: 266.82,
    x2: -5657.97,
    y2: 735.06,
    gradientTransform: "translate(-4998.38) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 495.34,
    y1: 78.61,
    x2: 495.34,
    y2: 342.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ffed5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f7e436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce7c1d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 567.34,
    y1: 265.62,
    x2: 621.41,
    y2: 360.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7e436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d58d21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 496.41,
    y1: 282.4,
    x2: 661.04,
    y2: 282.4,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1312.74,
    y1: 265.62,
    x2: -1258.67,
    y2: 360.38,
    gradientTransform: "translate(-886.03) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 415.99,
    y1: 250.62,
    x2: 414.32,
    y2: 339.25,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 487.48,
    y1: 259.57,
    x2: 506.71,
    y2: 727.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 527,
    y1: 652.37,
    x2: 481.01,
    y2: 424.11,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 541.37,
    y1: 673.19,
    x2: 576.46,
    y2: 734.69,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 495.33,
    y1: 684.08,
    x2: 602.18,
    y2: 684.08,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -1335.44,
    y1: 673.19,
    x2: -1300.34,
    y2: 734.69,
    gradientTransform: "translate(-886.03) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 442.45,
    y1: 663.45,
    x2: 441.37,
    y2: 720.98,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -1980.02,
    y1: -2866.12,
    x2: -1944.92,
    y2: -2804.61,
    gradientTransform: "translate(-1530.61 -2099.1) rotate(-180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 474.25,
    y1: 799.78,
    x2: 436.9,
    y2: 746.82,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1185.96,
    y1: -2866.12,
    x2: 1221.05,
    y2: -2804.61,
    gradientTransform: "translate(-644.58 -2099.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 521.6,
    y1: 819.14,
    x2: 548.35,
    y2: 755.04,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 494.54,
    y1: 674.59,
    x2: 498.58,
    y2: 880.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 500.88,
    y1: 741.96,
    x2: 492.28,
    y2: 699.3,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 350.55,
    y1: 648.68,
    x2: 307.35,
    y2: 577.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -2650.25,
    y1: 648.68,
    x2: -2693.45,
    y2: 577.05,
    gradientTransform: "translate(-2009) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 392.19,
    y: 276.29,
    width: 91.98,
    height: 85.66,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 392.19,
    y: -8573,
    width: 91.98,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 392.19,
    y: -8573,
    width: 91.98,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 438.18,
    cy: 319.12,
    fx: 438.18,
    fy: 319.12,
    r: 44.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 392.19,
    y: 276.29,
    width: 91.98,
    height: 85.66,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M438.18,276.29c-25.4,0-45.99,19.18-45.99,42.85s20.6,42.81,45.99,42.81,45.99-19.19,45.99-42.81-20.6-42.85-45.99-42.85Z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 438.18,
    cy: 319.12,
    fx: 438.18,
    fy: 319.12,
    r: 44.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1501.74,
    y1: -614.48,
    x2: 1560.06,
    y2: -512.26,
    gradientTransform: "translate(-821.67 146.11) rotate(34.06)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1434.63,
    y1: -593.73,
    x2: 1592.52,
    y2: -593.73,
    gradientTransform: "translate(-821.67 146.11) rotate(34.06)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -705.97,
    y1: 877.75,
    x2: -647.65,
    y2: 979.98,
    gradientTransform: "translate(-843.95 146.11) rotate(145.94) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -773.08,
    y1: 898.51,
    x2: -615.19,
    y2: 898.51,
    gradientTransform: "translate(-843.95 146.11) rotate(145.94) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M440.12,721.95s-42.51,20.58-116.58-8.68c-74.06-29.26-97.61-67.89-97.61-67.89l39.43-22.97s-41.09-32.2-57.54-91.63c-16.45-59.43-14.57-66.95-14.57-66.95h36.57s-10.97-12.66,9.14-77.57c20.12-64.92,39.31-77.65,39.31-77.65l27.43,28.38s11.88-29.24,42.06-54.84c30.17-25.6,61.26-36.56,61.26-36.56l36.55,52.22-5.46,424.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M214.52,541.14c-16.46-59.43-14.57-66.62-14.57-66.62h36.57s-10.97-12.99,9.14-77.9c20.12-64.92,39.32-77.81,39.32-77.81l27.43,28.3s11.88-29.28,42.06-54.88c26.12-22.16,52.9-33.36,59.64-35.97l-5.06-10.65s-31.09,10.97-61.26,36.57c-30.18,25.6-42.06,54.85-42.06,54.85l-27.43-28.35s-19.2,12.67-39.31,77.59c-20.11,64.92-9.14,77.57-9.14,77.57h-36.57s-1.88,7.51,14.57,66.95c6.84,24.68,17.92,44.8,28.54,59.71-8.39-13.45-16.45-29.83-21.86-49.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M277.4,621.25s-1.03-1.61-14.62,2.67l-36.83,21.45s2.24,3.66,7.48,9.57l43.97-33.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M445.59,297.81l-36.55-52.22s-31.09,10.97-61.26,36.57c-30.18,25.6-42.06,54.86-42.06,54.86l-27.43-28.35s-19.2,12.67-39.31,77.59c-20.11,64.91-9.14,77.57-9.14,77.57h-36.57s-1.88,7.51,14.57,66.95c16.46,59.43,57.54,91.57,57.54,91.57l-39.43,23s7.79,12.75,28.41,29.13c18.58,4.23,37.91,6.47,57.76,6.47,46.11,0,89.4-12.04,126.92-33.13l6.56-350.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M437.64,553.49l7.95-255.68-36.55-52.22s-31.09,10.97-61.26,36.57c-30.18,25.6-42.06,54.86-42.06,54.86l-27.43-28.35s-19.2,12.67-39.31,77.59c-20.11,64.91-9.14,77.57-9.14,77.57h-36.57s-1.88,7.51,14.57,66.95c.78,2.83,1.64,5.63,2.52,8.33,34.04,27,77.1,43.17,123.93,43.17,37.84,0,73.21-10.5,103.36-28.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M436.26,459.54l9.33-161.73-36.55-52.22s-31.09,10.97-61.26,36.57c-30.18,25.6-42.06,54.86-42.06,54.86l-27.43-28.35s-18.66,12.46-38.46,75c24.62,51.63,77.28,87.3,138.28,87.3,20.59,0,40.21-4.07,58.15-11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M326.12,304.4c14.81,30.5,46.09,51.52,82.27,51.52,9.14,0,17.96-1.36,26.29-3.86l10.91-54.25-36.55-52.22s-31.09,10.97-61.26,36.57c-8.69,7.37-15.85,15.04-21.66,22.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M229.83,457.42s-2.32-2.72-2.87-11.99c-.25,5.11-.05,7.72.33,11.99h2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M323.55,704.91c-56.57-22.35-83.65-50.15-93.29-62.04l-4.32,2.52s23.55,38.63,97.61,67.89c74.06,29.26,116.58,8.68,116.58,8.68l-.12-8.3c-2.53,1.16-44.67,19.61-116.45-8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M265.13,622.41l12.26-1.99s-53.23-38.57-69.69-98c-9.13-32.96-12.48-50.04-13.77-58.59h-.67s-2.01,7.51,14.45,66.95c12.68,45.79,42.1,79.33,57.43,91.63Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M549.37,721.95s42.51,20.58,116.57-8.68c74.06-29.26,97.61-67.89,97.61-67.89l-39.43-22.97s41.09-32.2,57.55-91.63c16.46-59.43,14.57-66.95,14.57-66.95h-36.57s10.97-12.66-9.14-77.57c-20.12-64.92-39.32-77.65-39.32-77.65l-27.43,28.38s-11.89-29.24-42.06-54.84c-30.17-25.6-61.26-36.56-61.26-36.56l-28.18,43.86-2.9,432.51Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M774.98,541.14c16.45-59.43,14.57-66.62,14.57-66.62h-36.57s10.97-12.99-9.15-77.9c-20.12-64.92-39.32-77.81-39.32-77.81l-27.43,28.3s-11.88-29.28-42.06-54.88c-26.11-22.16-52.9-33.36-59.63-35.97l5.06-10.65s31.09,10.97,61.26,36.57c30.17,25.6,42.06,54.85,42.06,54.85l27.43-28.35s19.2,12.67,39.32,77.59c20.11,64.92,9.14,77.57,9.14,77.57h36.57s1.89,7.51-14.57,66.95c-6.84,24.68-17.92,44.8-28.54,59.71,8.38-13.45,16.45-29.83,21.85-49.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M712.1,621.25s1.03-1.61,14.62,2.67l36.83,21.45s-2.24,3.66-7.48,9.57l-43.97-33.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M552.27,289.45l28.18-43.86s31.09,10.97,61.26,36.57c30.17,25.6,42.06,54.86,42.06,54.86l27.43-28.35s19.2,12.67,39.32,77.59c20.11,64.91,9.14,77.57,9.14,77.57h36.57s1.89,7.51-14.57,66.95c-16.46,59.43-57.55,91.57-57.55,91.57l39.43,23s-7.79,12.75-28.41,29.13c-18.57,4.23-37.91,6.47-57.76,6.47-46.1,0-89.4-12.04-126.92-33.13l1.81-358.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M551.85,553.49l.42-264.04,28.18-43.86s31.09,10.97,61.26,36.57c30.17,25.6,42.06,54.86,42.06,54.86l27.43-28.35s19.2,12.67,39.32,77.59c20.11,64.91,9.14,77.57,9.14,77.57h36.57s1.89,7.51-14.57,66.95c-.78,2.83-1.64,5.63-2.53,8.33-34.04,27-77.1,43.17-123.93,43.17-37.83,0-73.21-10.5-103.35-28.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M553.24,459.54l-.96-170.09,28.18-43.86s31.09,10.97,61.26,36.57c30.17,25.6,42.06,54.86,42.06,54.86l27.43-28.35s18.66,12.46,38.46,75c-24.61,51.63-77.28,87.3-138.29,87.3-20.58,0-40.21-4.07-58.14-11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M663.38,304.4c-14.82,30.5-46.08,51.52-82.27,51.52-9.14,0-17.96-1.36-26.29-3.86l-2.55-62.62,28.18-43.86s31.09,10.97,61.26,36.57c8.68,7.37,15.85,15.04,21.66,22.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M759.67,457.42s2.32-2.72,2.87-11.99c.25,5.11.05,7.72-.34,11.99h-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M665.94,704.91c56.58-22.35,83.65-50.15,93.29-62.04l4.31,2.52s-23.54,38.63-97.61,67.89c-74.06,29.26-116.57,8.68-116.57,8.68l.12-8.3c2.52,1.16,44.67,19.61,116.45-8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M724.37,622.41l-12.26-1.99s53.22-38.57,69.68-98c9.13-32.96,12.49-50.04,13.78-58.59h.67s2.01,7.51-14.45,66.95c-12.68,45.79-42.09,79.33-57.42,91.63Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "495.34 120.98 407.07 245.79 495.34 370.61 583.61 245.79 495.34 120.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "495.34 132.84 579.42 251.72 583.61 245.79 495.34 120.98 407.07 245.79 411.27 251.72 495.34 132.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "494.69 369.82 582.4 245.79 494.69 121.76 494.69 369.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "497.64 272.74 495.98 121.88 495.34 120.98 409.79 241.95 490.47 190.57 497.64 272.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "495.34 123.35 490.05 219.89 495.9 272.74 497.65 219.56 495.34 123.35"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "661.04 230.3 496.41 340.83 631 320.47 661.04 230.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "661.04 230.3 496.41 340.83 566.19 223.97 661.04 230.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "661.04 230.3 566.77 224.01 631.18 319.93 661.04 230.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "594 268.65 566.77 224.01 661.04 230.3 496.41 340.83 594 268.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "333.02 230.3 497.65 340.83 363.06 320.47 333.02 230.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "333.02 230.3 497.65 340.83 427.86 223.97 333.02 230.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "333.02 230.3 427.28 224.01 362.88 319.93 333.02 230.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "400.05 268.65 427.28 224.01 333.02 230.3 497.65 340.83 400.05 268.65"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M497.64,283.21c-127.08,0-230.08,100.15-230.08,223.68s103,223.71,230.08,223.71,230.08-100.17,230.08-223.71-103.02-223.68-230.08-223.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M496.96,720.58c-125.35,0-227.27-97.47-230.02-218.7-.04,1.67-.06,3.34-.06,5.02,0,123.55,103.01,223.71,230.09,223.71s230.07-100.17,230.07-223.71c0-1.68-.03-3.35-.07-5.02-2.74,121.23-104.68,218.7-230,218.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M497.64,283.21c-127.08,0-230.08,100.15-230.08,223.68,0,2.73.12,5.4.23,8.11,58.6,51.1,139.29,82.7,228.36,82.7s172.58-32.73,231.42-85.42c.05-1.81.15-3.57.15-5.39,0-123.53-103.02-223.68-230.08-223.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M681.25,371.52c-42.01-53.64-108.39-88.31-183.12-88.31s-142.13,35.19-184.11,89.53c52.01,31.23,114.9,49.52,182.62,49.52s132.21-18.76,184.6-50.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M497.64,296.01c124.84,0,226.4,96.74,229.9,217.29.07-2.12.18-4.25.18-6.4,0-123.53-103.02-223.68-230.08-223.68s-230.07,100.15-230.07,223.68c0,2.15.1,4.29.17,6.4,3.5-120.55,105.05-217.29,229.9-217.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M466.75,297.92c10.71-.82,21.75,3.25,16.4,7.91-5.36,4.65-41.57,25.54-57.36,12.63-15.82-12.93,28.37-19.58,40.96-20.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M342.26,354.79c-33.53,28.2-60.61,80.31-59.93,110.76.68,30.44,16.95-17.32,25.34-34.65,8.41-17.31,50.4-70.17,80.83-86.15,30.45-16.01,6.17-34.06-46.24,10.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M497.66,340.34c-94.49,0-171.08,74.48-171.08,166.33s76.59,166.33,171.08,166.33,171.05-74.47,171.05-166.33-76.57-166.33-171.05-166.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M497.38,684.08c-99.6,0-180.64-78.89-180.64-175.86s81.04-175.86,180.64-175.86,180.63,78.89,180.63,175.86-81.03,175.86-180.63,175.86ZM497.38,348.32c-90.8,0-164.69,71.73-164.69,159.9s73.89,159.9,164.69,159.9,164.67-71.73,164.67-159.9-73.87-159.9-164.67-159.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.66,340.34c-50.17,0-95.3,21-126.59,54.48,30.54-27.59,71.43-44.47,116.41-44.47,94.46,0,171.04,74.45,171.04,166.32,0,43.09-16.84,82.35-44.48,111.89,33.64-30.38,54.67-73.73,54.67-121.89,0-91.85-76.57-166.33-171.05-166.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M391.1,605.06c0-107.34,76.59-166.32,171.06-166.32,38.61,0,74.21,12.43,102.81,33.4-16.34-75.28-85.05-131.79-167.35-131.79-94.47,0-171.06,74.48-171.06,166.33,0,54.36,26.81,102.6,68.24,132.96-2.4-11.15-3.7-22.71-3.7-34.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M497.66,663.92c-92.83,0-168.33-71.92-170.92-161.56-.07,1.59-.15,3.17-.15,4.78,0,91.88,76.59,166.33,171.08,166.33s171.05-74.45,171.05-166.33c0-1.61-.07-3.19-.11-4.78-2.62,89.64-78.11,161.56-170.93,161.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "602.18 650.27 495.33 722 582.69 708.79 602.18 650.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "602.18 650.27 495.33 722 540.62 646.16 602.18 650.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "602.18 650.27 541 646.18 582.8 708.43 602.18 650.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "558.68 675.16 541 646.18 602.18 650.27 495.33 722 558.68 675.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "388.6 650.27 495.45 722 408.09 708.79 388.6 650.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "388.6 650.27 495.45 722 450.16 646.16 388.6 650.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "388.6 650.27 449.78 646.18 407.98 708.43 388.6 650.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "432.1 675.16 449.78 646.18 388.6 650.27 495.45 722 432.1 675.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "388.6 789.95 495.44 718.21 408.09 731.42 388.6 789.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "388.6 789.95 495.44 718.21 450.16 794.05 388.6 789.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "388.6 789.95 449.78 794.03 407.98 731.78 388.6 789.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "434.64 771.49 449.78 794.03 388.6 789.95 428.88 762.9 434.64 771.49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "602.18 789.95 495.33 718.21 582.69 731.42 602.18 789.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "602.18 789.95 495.33 718.21 540.62 794.05 602.18 789.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "602.18 789.95 541 794.03 582.8 731.78 602.18 789.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "557.7 769.16 541 794.03 602.18 789.95 561.9 762.9 557.7 769.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "495.34 660.88 407.07 715.58 495.34 770.28 583.61 715.58 495.34 660.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "495.34 666.08 579.42 718.18 583.61 715.58 495.34 660.88 407.07 715.58 411.27 718.18 495.34 666.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "494.69 769.93 582.4 715.58 494.69 661.22 494.69 769.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "495.4 769.16 493.73 703.05 495.34 660.88 409.79 713.89 466.36 728.98 495.4 769.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "495.34 661.92 407.07 715.58 495.34 712.11 583.61 715.58 495.34 661.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M495.39,683.65c-17.66,0-31.97,13.92-31.97,31.08s14.32,31.09,31.97,31.09,31.97-13.92,31.97-31.09-14.31-31.08-31.97-31.08Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M495.34,747.89c-18.62,0-33.76-14.74-33.76-32.87s15.15-32.87,33.76-32.87,33.76,14.74,33.76,32.87-15.14,32.87-33.76,32.87ZM495.34,685.14c-16.97,0-30.78,13.4-30.78,29.88s13.81,29.88,30.78,29.88,30.78-13.4,30.78-29.88-13.81-29.88-30.78-29.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M495.39,683.65c-9.38,0-17.81,3.92-23.66,10.18,5.71-5.15,13.35-8.31,21.76-8.31,17.65,0,31.97,13.91,31.97,31.08,0,8.05-3.15,15.39-8.31,20.91,6.29-5.68,10.22-13.78,10.22-22.78,0-17.16-14.31-31.08-31.97-31.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M475.48,733.12c0-20.06,14.32-31.08,31.97-31.08,7.21,0,13.87,2.32,19.22,6.24-3.06-14.07-15.9-24.63-31.28-24.63-17.65,0-31.97,13.92-31.97,31.08,0,10.16,5.01,19.18,12.76,24.85-.45-2.08-.7-4.24-.7-6.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M293.4,611.27s8.58,14.21,17.81,27.58l47.88-30.53-65.68,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M335.71,666.46l23.91-58.17-.53.02-47.88,30.53c.94,1.36,1.88,2.7,2.82,4.02,10.22,14.37,21.68,23.6,21.68,23.6Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "360.24 608.32 342.83 673 335.71 666.46 360.24 608.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "292.1 606.2 293.4 611.27 360.24 608.32 292.1 606.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M698.4,611.27s-8.58,14.21-17.81,27.58l-47.88-30.53,65.69,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M656.09,666.46l-23.9-58.17.52.02,47.88,30.53c-.93,1.36-1.87,2.7-2.81,4.02-10.22,14.37-21.68,23.6-21.68,23.6Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "631.56 608.32 648.97 673 656.09 666.46 631.56 608.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "699.71 606.2 698.4 611.27 631.56 608.32 699.71 606.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M438.18,276.29c-25.4,0-45.99,19.18-45.99,42.85s20.6,42.81,45.99,42.81,45.99-19.19,45.99-42.81-20.6-42.85-45.99-42.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M396.18,375.5c12.34-13.85,48.63-56.36,48.63-56.36,0,0,30.31-56.89,31.05-58.49.2-.46-38.74,53.49-38.74,53.49l-40.94,61.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M448.18,308.95c-11.18-8.75-9.15-33.34-9.24-40.3v6.67c0-1.06-.08-2.21-.08-2.46v-4.2c-.01,2-.15,5.16-.62,8.81,0,0-3.28,24.68-9.19,29.78-13.32,11.69-46.85,9.43-33.99,9.73,43.42.93,43.42,43.31,43.81,57.21v-7c.03.5.08.92.08,1.17v5.83c.92-32.91.81-53.73,38.69-56.51,12.55-.96-16.37,1.45-29.45-8.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "859.89 502.11 669.74 501.5 718.64 560 859.89 502.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "859.89 502.11 669.74 501.5 718.98 443.76 859.89 502.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "859.89 502.11 719.45 444.11 726.96 501.88 719.09 559.65 859.89 502.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "724.69 496.35 719.45 444.11 859.89 502.11 669.74 501.5 724.69 496.35"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "139.23 502.11 329.39 501.5 280.48 560 139.23 502.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "139.23 502.11 329.39 501.5 280.14 443.76 139.23 502.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "139.23 502.11 279.67 444.11 272.16 501.88 280.03 559.65 139.23 502.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "274.43 496.35 279.67 444.11 139.23 502.11 329.39 501.5 274.43 496.35"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.3185b7989a5940307fe9304436dce6a0.svg";
export { ForwardRef as ReactComponent };